<div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" *ngSubscribe="allowedToCreateNew$ as allowedToCreateNew">
    <!-- Header and add new button -->
    <div class="row justify-content-between no-gutters mb-4">
        <div class="col-auto mr-auto">
            <h1 i18n="@@contentpagecenter-title" class="h4">Page Center</h1>
        </div>
        <div class="col-auto">
            <a mat-flat-button *ngIf="allowedToCreateNew" [routerLink]="['add']" color="accent">
                <span i18n="@@contentpagecenter-create-new-button">Add Page</span>
            </a>
        </div>
    </div>
    <app-page-center [pageType]="pageType" [editorOptionsEnabled]="allowedToCreateNew"></app-page-center>
</div>